import { Component, OnInit, Input, Inject } from '@angular/core';
import { IQuestionsAndAnswersContainerResult } from '../../models/magazine-result';
import { MagazineService } from '../../interfaces/magazine-service.interface';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'lib-questions-and-answers',
    templateUrl: './questions-and-answers.component.html',
    styleUrls: ['./questions-and-answers.component.scss']
})
export class QuestionsAndAnswersComponent implements OnInit {
    constructor(
        @Inject(DOCUMENT) private readonly document: any,
        private magazineSvc: MagazineService,
        public sanitizer: DomSanitizer
    ) {}

    @Input() content: IQuestionsAndAnswersContainerResult;

    ngOnInit() {
        this.createExpandIconStyle();
    }

    createExpandIconStyle() {
        if (
            this.document.head.querySelector(
                `style[id="magazineArticleExpandStyle"]`
            )
        ) {
            return;
        }

        const styleElement = this.document.head.appendChild(
            this.document.createElement('style')
        ) as HTMLStyleElement;

        styleElement.setAttribute('type', 'text/css');
        styleElement.setAttribute('id', 'magazineArticleExpandStyle');
        styleElement.innerHTML = `.magazine .how-its-work .answer-question h4 a[aria-expanded=false]:before {background: url(${this.magazineSvc.getQAndAExpandIconUrl()}) no-repeat;}
                                    .magazine .how-its-work .answer-question a[aria-expanded=true]:before {background: url(${this.magazineSvc.getQAndACollapseIconUrl()}) no-repeat;}`;
    }

    onQuestionClicked(question: string, event) {
        const questionOpen =
            event.currentTarget.attributes.getNamedItem('aria-expanded')
                .nodeValue === 'false';
        if (questionOpen) {
            // this.magazineSvc.pushToGtmLoansLobby('Q and A', question);
        }
    }
}
